<script setup>
import AdvancedMonitoringManager from '@/views/apps/monitoring/list/AdvancedMonitoringManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = Number.parseInt(route.params.id)
</script>

<template>
  <AdvancedMonitoringManager
    :bot-id="botId"
    :show-bot-filter="false"
    :show-add-new="false"
  />
</template>
